// Instructivos de uso del PLM. Cada paso = una captura (public/instructivos/<id>/<nn>.webp) + una explicación breve.
// Las capturas se regeneran con scripts/instructivos/capturar.py (datos inventados, nunca reales).
// En el texto, **así** se muestra en negritas.

export const INSTRUCTIVOS = [
  {
    id: "entrar",
    titulo: "Entrar al PLM y moverse",
    para: "Todos",
    resumen: "Iniciar sesión, usar el menú, ver avisos y encontrar un modelo.",
    pasos: [
      { img: "01", texto: "Entra a **plm-aretina.com** con tu correo de la empresa y tu contraseña, y da clic en **Entrar**." },
      { img: "02", texto: "El **menú de la izquierda** te lleva a cada sección. Solo ves las secciones que tu rol tiene permitidas." },
      { img: "03", texto: "El **Dashboard** resume cómo va todo: avance por colección, modelos por etapa y los modelos más atorados." },
      { img: "04", texto: "La **campana** muestra tus avisos (menciones, solicitudes y cambios). El número rojo son los que no has leído." },
      { img: "05", texto: "En **Colecciones** da clic en la temporada o el cliente que necesitas." },
      { img: "06", texto: "Para encontrar un modelo, escribe su **nombre o SKU** en el buscador. Da clic en la fila para abrir su ficha." },
      { img: "07", texto: "Con este botón **ocultas el menú** para ganar espacio en la pantalla. Para volver a abrirlo, usa el botón de arriba a la izquierda." },
      { img: "08", texto: "Para salir, da clic en **Cerrar sesión**, sobre todo si usas una computadora compartida." },
      { img: "09", texto: "Si tienes dudas de cómo hacer algo, en **Instructivos** están todas las guías y las puedes descargar en PDF." },
    ],
  },
  {
    id: "solicitud-modelo",
    titulo: "Pedir un modelo nuevo y autorizarlo",
    para: "Comercial, Diseño y quien autoriza",
    resumen: "Crear la solicitud de un modelo y autorizarla para que entre a una colección.",
    pasos: [
      { img: "01", texto: "En **Solicitudes**, da clic en **Nuevo modelo**." },
      { img: "02", texto: "Escribe el **nombre del modelo** y elige la **ruta de desarrollo** (modelo nuevo, horma existente o nuevo color). La ruta define qué pasos lleva." },
      { img: "03", texto: "Llena la **organización del producto**: categoría, género, estrategia y ciclo de vida. Lo que falte se puede completar después en la ficha." },
      { img: "04", texto: "Agrega **notas de desarrollo** si hay algo que el equipo deba saber y da clic en **Enviar solicitud**." },
      { img: "05", texto: "La solicitud queda **Pendiente**. Quien tiene permiso de autorizar ve los botones **Autorizar** y **Rechazar**." },
      { img: "06", texto: "Al autorizar, elige la **colección** donde va el modelo, revisa la ruta y da clic en **Autorizar**." },
      { img: "07", texto: "Listo: el modelo ya aparece en su colección y arranca en el primer paso de su ruta." },
    ],
  },
  {
    id: "avanzar-modelo",
    titulo: "Avanzar un modelo: compuertas y documentos",
    para: "Diseño, Desarrollo e Ingeniería de producto",
    resumen: "Subir el documento de un paso y marcarlo como hecho.",
    pasos: [
      { img: "01", texto: "En la colección, abre el modelo dando clic en su fila. Con las cards de arriba puedes ver solo los de tu etapa." },
      { img: "02", texto: "En **Proceso de desarrollo** están los pasos agrupados por área. Solo puedes marcar los pasos de tu área." },
      { img: "03", texto: "Los pasos con **Documento** tienen candado: primero da clic en **Subir** y elige el archivo en el formato que se indica. Si hay plantilla, se descarga ahí mismo." },
      { img: "04", texto: "Con el archivo arriba se quita el candado. Da clic en la **casilla** para marcar el paso como hecho." },
      { img: "05", texto: "El paso queda en verde con la **fecha y quién lo marcó**, y el modelo avanza al siguiente paso." },
      { img: "06", texto: "Si el documento cambia, usa **Nueva versión**: las anteriores se guardan. Con **Ver** abres el documento vigente." },
    ],
  },
  {
    id: "colecciones",
    titulo: "Colecciones: filtros, notas y cambios en grupo",
    para: "Todos",
    resumen: "Filtrar con las cards de etapa, leer notas y cambiar varios modelos a la vez.",
    pasos: [
      { img: "01", texto: "Da clic en una **card de etapa** para ver solo los modelos de esa etapa. La card activa se marca con su color." },
      { img: "02", texto: "El filtro **Etapa** cambia junto con la card. Otro clic en la card (o **Etapa: Todos**) quita el filtro. Se combina con los demás filtros y el buscador." },
      { img: "03", texto: "El ícono amarillo en **Notas** indica que el modelo tiene notas de desarrollo. **Pasa el cursor** encima para leerlas." },
      { img: "04", texto: "Para cambiar varios modelos a la vez, da clic en **Seleccionar**." },
      { img: "05", texto: "Marca las casillas de los modelos. En la barra azul eliges qué cambiar: diseñador, colección, categoría y más, según tu rol." },
      { img: "06", texto: "Elige el nuevo valor y da clic en **Aplicar**. El cambio se hace en todos los seleccionados." },
      { img: "07", texto: "Al terminar, da clic en **Terminar selección** para ocultar las casillas." },
    ],
  },
  {
    id: "hormas",
    titulo: "Hormas: alta, revisión, liberación y modificación",
    para: "Desarrollo",
    resumen: "Dar de alta una horma, liberarla y pedir una modificación.",
    pasos: [
      { img: "01", texto: "En **Hormas** da clic en **Nueva horma**." },
      { img: "02", texto: "Captura el **código** y el **nombre** (hormero y género son opcionales) y da clic en **Dar de alta**. La horma arranca en **Captura de medidas**." },
      { img: "03", texto: "En la **Ficha de la horma** da clic en **Editar**." },
      { img: "04", texto: "Captura las medidas: **central, largo, recio, cintura y empeine** son obligatorias. Da clic en **Guardar**." },
      { img: "05", texto: "Sube las dos fotos: **lado externo** y **lado interno**." },
      { img: "06", texto: "Con medidas y fotos, da clic en **Dar de alta**. La horma queda **Revisada** y ya se puede elegir en los modelos." },
      { img: "07", texto: "Para liberarla, adjunta el archivo **Pull Over & Prueba de Calce**." },
      { img: "08", texto: "Con el archivo adjunto, da clic en **Liberar horma**." },
      { img: "09", texto: "La horma queda **Liberada**. Arriba puedes generar el **formato FDD-08**." },
      { img: "10", texto: "Una horma revisada o liberada no se edita directo: si algo cambió, da clic en **Pedir modificación**." },
      { img: "11", texto: "Escribe el **motivo** (mínimo 10 letras) y confirma. La horma pasa a **En modificación** y los modelos que la usan se detienen hasta que se vuelva a dar de alta." },
    ],
  },
  {
    id: "muestras",
    titulo: "Muestras: pedir, avanzar, entregar y confirmar",
    para: "Comercial y Desarrollo",
    resumen: "Todo el camino de una muestra, de la solicitud a la recepción.",
    pasos: [
      { img: "01", texto: "En **Solicitudes** da clic en **Nueva muestra**." },
      { img: "02", texto: "Escribe el **cliente**, la fecha requerida y los productos: SKU, producto, color, talla y cantidad." },
      { img: "03", texto: "Con **Agregar producto** sumas más renglones. Al terminar, da clic en **Enviar solicitud**." },
      { img: "04", texto: "La solicitud queda pendiente. Quien tiene permiso da clic en **Autorizar** (o **Rechazar**, con el motivo)." },
      { img: "05", texto: "Confirma con **Autorizar**. La muestra ya aparece en el menú **Muestras**." },
      { img: "06", texto: "En **Muestras** ves las solicitudes **En curso, Entregadas y Canceladas**. Da clic en una para abrirla." },
      { img: "07", texto: "Desarrollo captura la **Fecha de entrega** y da clic en **Guardar fecha**. Es obligatoria antes de avanzar los productos y se le avisa al solicitante." },
      { img: "08", texto: "Si un producto ya no se necesita, usa **Cancelar** en su renglón; para cancelar todo, **Cancelar solicitud**. Las dos piden el motivo." },
      { img: "09", texto: "En **Tablero de productos** cada tarjeta avanza con la **flecha** (corte, pespunte, montado, adorno, terminado y entregado). También se pueden arrastrar." },
      { img: "10", texto: "Al pasar a **Entregado** se pide confirmar. Al aceptar, se le avisa al solicitante." },
      { img: "11", texto: "El solicitante abre la muestra y da clic en **Confirmar recepción** (o **Rechazar** si llegó mal). Si no responde en 48 horas, se confirma sola." },
    ],
  },
  {
    id: "comentarios",
    titulo: "Comentar y mencionar a alguien",
    para: "Todos",
    resumen: "Dejar un comentario en un modelo y avisarle a una persona.",
    pasos: [
      { img: "01", texto: "Al final de la ficha del modelo está **Comentarios**. Escribe tu comentario en el recuadro." },
      { img: "02", texto: "Para avisarle a alguien, escribe **@** y las primeras letras de su nombre, y elígelo de la lista." },
      { img: "03", texto: "La persona queda mencionada. Da clic en el **botón de enviar**." },
      { img: "04", texto: "El comentario queda en el modelo con tu nombre y la fecha. La persona mencionada recibe el aviso en su **campana** y por correo." },
    ],
  },
  {
    id: "depurar",
    titulo: "Depurar y reactivar un modelo",
    para: "Admin y roles con permiso",
    resumen: "Sacar un modelo que ya no se va a desarrollar y, si se retoma, reactivarlo.",
    pasos: [
      { img: "01", texto: "En la ficha del modelo, da clic en **Acciones** y elige **Depurado**. Se usa cuando un modelo ya no se va a desarrollar." },
      { img: "02", texto: "Escribe el **motivo** (es obligatorio) y confirma." },
      { img: "03", texto: "El modelo queda marcado como **Depurado**: ya no cuenta como pendiente y se va al final de la colección." },
      { img: "04", texto: "Si se retoma, en **Acciones** elige **Reactivar**." },
      { img: "05", texto: "Escribe el **motivo** y confirma. El modelo regresa con el avance que tenía." },
    ],
  },
  {
    id: "administracion",
    titulo: "Administración: usuarios, permisos, listas y plantillas",
    para: "Admin",
    resumen: "Dar de alta usuarios, ajustar permisos de un rol y mantener listas y plantillas.",
    pasos: [
      { img: "01", texto: "En **Usuarios** da clic en **Nuevo usuario**." },
      { img: "02", texto: "Captura nombre, correo y una contraseña inicial, elige su **rol** y da clic en **Guardar**. Entrégale la contraseña en persona." },
      { img: "03", texto: "Con el **lápiz** cambias el rol o los datos de un usuario." },
      { img: "04", texto: "En **Roles y permisos** abre el rol que quieras ajustar." },
      { img: "05", texto: "Busca el permiso, márcalo o desmárcalo y da clic en **Guardar**. El cambio aplica a todos los usuarios con ese rol." },
      { img: "06", texto: "En **Listas** se agregan opciones nuevas (categorías, géneros, estrategias…): escribe el valor y da clic en **+**." },
      { img: "07", texto: "En **Plantillas** se sube el formato que se descarga en cada paso (por ejemplo, la carta proto). Usa **Subir** o **Reemplazar** en el paso que corresponda." },
    ],
  },
];

export const instructivoPorId = (id) => INSTRUCTIVOS.find((i) => i.id === id);
